import { useIntl } from "react-intl";
import { WmButton } from "@watermarkinsights/ripple-react";
import type { AgentMessage } from "../ai-chat-message-utils";
import { ChatMessage } from "../messages/ChatMessage";
import { ChatIntroPanel } from "../messages/ChatIntroPanel";

interface ChatMessageListProps {
  isIntroState: boolean;
  visibleMessages: AgentMessage[];
  latestUserMessageId: string | null;
  isAwaitingAgentResponse: boolean;
  isRunning: boolean;
  shouldShowTypingIndicator: boolean;
  isJumpToLatestVisible: boolean;
  messagesContainerRef: React.RefObject<HTMLDivElement>;
  latestExchangeAnchorRef: React.RefObject<HTMLDivElement>;
  messagesEndRef: React.RefObject<HTMLDivElement>;
  onScroll: () => void;
  onQuestionSelected: (question: string) => void;
  onJumpToLatest: () => void;
}

export const ChatMessageList = ({
  isIntroState,
  visibleMessages,
  latestUserMessageId,
  isAwaitingAgentResponse,
  isRunning,
  shouldShowTypingIndicator,
  isJumpToLatestVisible,
  messagesContainerRef,
  latestExchangeAnchorRef,
  messagesEndRef,
  onScroll,
  onQuestionSelected,
  onJumpToLatest,
}: ChatMessageListProps) => {
  const intl = useIntl();

  return (
    <div className="tcw-messages-wrapper">
      <div className="tcw-messages" ref={messagesContainerRef} onScroll={onScroll}>
        {isIntroState && <ChatIntroPanel onQuestionSelected={onQuestionSelected} />}
        {visibleMessages.map((message, index) => (
          <ChatMessage
            key={message.id}
            message={message}
            onQuestionSelected={
              index === visibleMessages.length - 1 &&
              !isAwaitingAgentResponse &&
              !isRunning
                ? onQuestionSelected
                : undefined
            }
            latestExchangeAnchorRef={
              message.id === latestUserMessageId ? latestExchangeAnchorRef : undefined
            }
          />
        ))}
        {shouldShowTypingIndicator && (
          <div className="tcw-message tcw-message--assistant--typing">
            <img
              src="https://cdn.watermarkinsights.com/images/loaders/ai-pulsing-dot-loader.svg"
              alt="Loading"
              className="tcw-loading-loader"
            />{" "}
            {intl.formatMessage({ id: "app.toolboxChat.typing.thinking" })}
          </div>
        )}
        <div ref={messagesEndRef} />
      </div>
      {isJumpToLatestVisible && (
        <WmButton
          button-type="icononly"
          tooltip={intl.formatMessage({ id: "app.toolboxChat.action.jumpToLatest" })}
          tooltip-position="top"
          icon="#move-down"
          icon-size="18px"
          className="tcw-jump-to-latest-btn"
          onClick={onJumpToLatest}
        />
      )}
    </div>
  );
};
